<template>
  <div class="termination-page">
<h2>【重要】サービス終了のお知らせ</h2>
<dl>
平素ご愛顧いただき、誠にありがとうございます。<br>
占いTVは、2023年5月31日をもちましてサービスを終了いたしました。<br>
<br>
これまでのご愛顧に厚くお礼申し上げます。

<br><br>
記<br><br>
■提供終了サービス ：占いTV<br>
■サービス終了日 ：2023年5月31日（水）<br>
<br>
<br>
■お問い合わせ先<br>
上記内容に関するお問い合わせは、下記にて承ります。<br>
<br>
株式会社ザッパラス<br>
<a href="https://www.zappallas.com/contact/">https://www.zappallas.com/contact/</a><br>
<br>
<br>
</dl>
<div class="center">
  <p><2023年4月新規公開><br>
暮れの酉の占いは<br>
こちらでお楽しみいただけます</p>
<a href="https://kurenotori.jp?utm_source=uranai.tv&utm_medium=referral&utm_campaign=LO00100003"><img src="/static/img/banner/kurenotori_1.jpg" alt=""></a>

</div>

  </div>
</template>

<script>
export default {
  name: "TerminationPage",
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.termination-page {
  color: $col_base_black;
  font-size: 13px;
  line-height: 1.7;
  padding: 1px 4px 30px;
  h2 {
    font-weight: bold;
    font-size: 21px;
    text-align: center;
    margin: 45px 0 30px;
  }
  dl {
    padding: 0;
    margin: 0 0 1em;
    > dt {
      font-weight: bold;
      font-size: 13px;
      margin: 1.6em 0 1em;
      &:first-child {
        margin-top: 0;
      }
    }
    > dd {
      margin: 0 0 1em;
    }
  }
  ul {
    padding: 0;
    margin: 1em 0;
    > li {
      list-style: disc inside;
      margin: 0 0 0.5em 1.7em;
      text-indent: -1.3em;
    }
  }
  a {
    color: inherit;
  }
  b {
    font-weight: bold;
  }
  small {
    color: $col_temp_gray6;
    font-size: inherit;
  }
  .center{
    text-align: center;
    font-size: 14px;
    img{width: 300px;}
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Help/Termination.vue